import { z } from 'zod';
export const offerRequestCloningTreeNodeSchema = z.object({
    id: z.number(),
    clonedFromId: z.number().nullable(),
    isDeleted: z.boolean(),
});
export const offerRequestCloningTreeResponseSchema = z.array(offerRequestCloningTreeNodeSchema);
